<template>
  <div  style="margin:20px 30px;">
    <div v-if="cjList.length>1">
      <div class="container">
        <div>
          <header-com :project='project'></header-com>
        </div>
        <vggrid ref="xGrid" :list="list" tableheight="700" flexname=""
                :cols="cols"
                :showfooter="false"
                :showPage="false" :resizable="true"
                @cellClick="cellClick" @cellDblClick="viewProject" :canbeEdit="true">
        </vggrid>
      </div>
    </div>
    <div v-else>
      <pj-bidding-file :psuid="list[0].psuid" :projectid="list[0].projectid" v-if="list.length>0"></pj-bidding-file>
    </div>
  </div>
</template>
<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vggrid from '../common/vggrid'
  import PbidConfirmFeeAmtForm from '../jjgl/pbidConfirmFeeAmtForm'
  import pjBiddingFile from './pjBiddingFile'
  import headerCom from '../component/headerCom'
  import dayjs from 'dayjs'
  export default {
    name: 'pbidConfirmFile',
    data () {
      return {
        dialogVisible: false,
        cjList:[],
        list: [],
        psu:{},
        newPsuList: [],
        comList:[],
        project: {},
        cols: [],
        loading: true,
        formLabelWidth: '100px',
        disable: false
      }
    },
    created () {
    },
    activated() {
    },
    async mounted () {
      await this.init()
      await this.getModel()
      await this.getPsuList()
    },
    computed:{
      dialogName () {
        if (+this.$store.getters.loginUser.comtype === 1) {
          return '服务费确认'
        } else if (+this.$store.getters.loginUser.comtype === 2) {
          return '确认成交'
        }
      },
    },
    components: {vggrid, PbidConfirmFeeAmtForm,headerCom,pjBiddingFile},
    methods: {
      dialogClose () {
        this.getPsuList()
        this.dialogVisible = false
      },
      async init() {
        this.list = []
        this.cjList = []
        this.cols = []
        this.comList = []
        this.project = {}
        this.disable = false
      },
      async getModel () {
        this.cols =  [
          { field: 'comfullname', fieldtype: 'C', title: '供应商',calculExpr:'',addNewRowFlg: false},
          { field: 'username', fieldtype: 'C', title: '经办人',calculExpr:'',addNewRowFlg: false},
          // { field: 'psuamt1', fieldtype: 'F', title: '最终报价',calculExpr:'',addNewRowFlg: false},
          { field: 'psuoffertime', fieldtype: 'F', title: '报价时间',calculExpr:'',addNewRowFlg: false},
          // {field: 'psuoffertime', fieldtype: 'C', title: '报价时间', calculExpr: '', addNewRowFlg: false},
          { field: 'psuas', fieldtype: 'F', title: '得分',calculExpr:'',addNewRowFlg: false},
          { field: 'psubidorder',fieldtype: 'C', title: '排名',calculExpr:'', width: 80 },
          { type: 'checkbox',fieldtype: 'I', title: '成交',calculExpr:'', width: 80 }
        ],
        this.loading = true
        this.btnLoading = true
        let res = await request({
          method: 'get',
          url: '/xmgl/project/findProjectById',
          params: {projectid: this.$route.query.projectid}
        })
        this.project = res
          if(+this.project.projectquotationmode === 1){
            this.cols.splice(2,0,{field: 'psuamt1', title:'最终报价', calculExpr: '', addNewRowFlg: false})
          }else if(+this.project.projectquotationmode === 2){
            this.cols.splice(2,0,{field: 'psupricerate', title:'上浮率%', calculExpr: '', addNewRowFlg: false})
          }else if(+this.project.projectquotationmode === 3){
            this.cols.splice(2,0,{field: 'psupricerate', title:'下浮率%', calculExpr: '', addNewRowFlg: false})
          }else if(+this.project.projectquotationmode === 4){
            this.cols.splice(2,0,{field: 'psupricerate', title:'折扣率%', calculExpr: '', addNewRowFlg: false})
          }
      },
    
      async cellClick (row) {
        this.psu = row.row
      },
      async toCJGG(){
        let {href} = this.$router.resolve({name: 'pjnoticebypid', query: {projectid: this.project.projectid,pjnoticetype:60}})
        window.open(href, '_blank')
      },
      async projectResultNotice(){
        this.$router.push({name: 'pjnoticeIndex', params: {projectid:this.project.projectid,type: 1}})
      },
      async viewWinningBid(row){
          this.psu = row
          if(+this.psu.psubidflg != 1){
            this.$message.warning('该单位未成交！')
            return
          }
          // this.$router.push({name: 'projectBiddingNotice', params: {psuid: this.psu.psuid,projectid: this.project.projectid}})
          let {href} = this.$router.resolve({name: 'pjBiddingNotice', query: {psuid: this.psu.psuid,projectid: this.project.projectid}})
          window.open(href, '_blank')
      },
      async toEditWinningBid(row){
        this.psu = row
        this.$router.push({name: 'editWinningBid', params: {psuid: this.psu.psuid,projectid:this.project.projectid,type: 1}})
      },
      async setRadioRow() {
        let Index = this.list.findIndex(item => item.psubidflg === 1)
        if (Index!==-1) {
          this.disable = true
          // this.$refs.xGrid.$refs.xGrid.setRadioRow(this.list[Index])
          if(this.cols.slice(-1)[0].title != '操作'){
            this.cols.push({ title: '操作', width: 120, showOverflow: true,
              slots: {
                default: ({row}) => {
                //   if(+row.psubidflg === 1 && +row.psubcnflg === 1){
                //     return [<vxe-button type="primary" onClick={this.toEditWinningBid.bind(this,row)}>编写通知书</vxe-button>]
                //   }
                //   else if(+row.psubidflg === 1 && +row.psubcnflg === 2){
                //     return [<vxe-button type="primary" onClick={this.viewWinningBid.bind(this,row)}>通知书</vxe-button>]
                //   }
                    if(+row.psubidflg === 1 && +row.psubcnflg === 2){
                      return [<vxe-button type="primary" onClick={this.viewWinningBid.bind(this,row)}>通知书</vxe-button>]
                    }
                }}
            })

          }
        }
      },
      async getPsuList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getPsuListByBidflg',
          params: {projectid: this.$route.query.projectid, yxflag: 1}
        })
        this.list = res
        this.setRadioRow()
        this.list.forEach(key => {
          key.psuamt1 = utils.comdify(key.psuamt);
          key.username = key.username + " " + key.usermobile
          key.psuoffertime = dayjs(key.psuoffertime).format('YYYY-MM-DD HH:mm:ss SSS')
        });
        this.cjList = this.list.filter(e=>{
          return e.psubidflg
        })
        this.loading = false
      },
      async viewProject(row) {
        this.psu = row.row
        this.$router.push({name: 'psuBmForm', params: {psuid: this.psu.psuid}})
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'pbidConfirmIndex'})
      }
    },
    filters: {
    }
  }
</script>

<style lang="scss">
  .status {
    color: red;
    padding-left: 10px;
  }

</style>
